import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const t = typeof window !== "undefined" ? localStorage.getItem("studiomv_token") : null;
  if (t) cfg.headers = { ...cfg.headers, Authorization: `Bearer ${t}` };
  return cfg;
});

// Silently swallow "upgrade_required" 403s so feature-gated background fetches don't crash the UI.
// Pages that genuinely need the data should check `hasFeature(...)` from AuthContext first.
api.interceptors.response.use(
  (res) => res,
  (error) => {
    const detail = error?.response?.data?.detail;
    const isUpgradeRequired =
      error?.response?.status === 403 &&
      detail &&
      typeof detail === "object" &&
      detail.error === "upgrade_required";
    if (isUpgradeRequired) {
      // Return a soft, normalized response so callers see "no data" instead of an exception.
      return Promise.resolve({
        data: null,
        status: 403,
        upgrade_required: true,
        feature: detail.feature,
        config: error.config,
        headers: error.response?.headers,
      });
    }
    return Promise.reject(error);
  }
);

export default api;

export function setToken(t) {
  if (t) localStorage.setItem("studiomv_token", t);
  else localStorage.removeItem("studiomv_token");
}

export function formatApiError(detail) {
  if (detail == null) return "Etwas ist schiefgelaufen.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function fileUrl(pathOrUrl) {
  if (!pathOrUrl) return null;
  if (pathOrUrl.startsWith("http")) return pathOrUrl;
  if (pathOrUrl.startsWith("/api/")) return `${BACKEND_URL}${pathOrUrl}`;
  return pathOrUrl;
}
